import { Static, Type } from "@sinclair/typebox";

export const GroupMemberTypes = Type.Union([
  Type.Literal("lead"),
  Type.Literal("user"),
  Type.Literal("contact"),
  Type.Literal("account"),
  Type.Literal("person account"),
]);

export type GroupMemberTypesType = Static<typeof GroupMemberTypes>;
export const WhatsllyGroupMember = Type.Object({
  id: Type.String(),
  type: GroupMemberTypes,
  name: Type.Optional(Type.String()),
  phone: Type.String(),
  isPersonAccount: Type.Optional(Type.Boolean()),
  recordTypeId: Type.Optional(Type.String()),
  companyNameOrAccountName: Type.Optional(Type.String()),
});

export type WhatsllyGroupMemberType = Static<typeof WhatsllyGroupMember>;
export const WhatsllyGroup = Type.Object({
  Id: Type.String(),
  members: Type.Array(WhatsllyGroupMember),
});

export type WhatsllyGroupType = Static<typeof WhatsllyGroup>;
